import { SourceComponents } from '@updater/informant-core';
import { Checkbox } from '@updater/ui-uds';

export const ToggleField: SourceComponents['ToggleField'] = (props) => {
  return <Checkbox {...props} />;
};
